import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import ITreatmentCategory from '../../../_interfaces/ITreatmentCategory';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { SessionService } from '../../../_services/session/session.service';
import { TreatmentsCategoriesService } from '../../../_services/treatments/treatments-categories.service';
import { BaseComponent } from '../../base/base.component';
import { AdminStatePanelComponent } from '../../admin-ui/admin-state-panel/admin-state-panel.component';
import { AdminTableActionsComponent } from '../../admin-ui/admin-table-actions/admin-table-actions.component';
import { AdminListToolbarComponent } from '../../admin-ui/admin-list-toolbar/admin-list-toolbar.component';

@Component({
  standalone: true,
  selector: 'app-table-categories-treatments',
  templateUrl: './table-categories-treatments.component.html',
  styleUrls: ['./table-categories-treatments.component.scss'],
  imports: [
    CommonModule,
    TableModule,
    TranslatePipe,
    ButtonModule,
    AdminStatePanelComponent,
    AdminTableActionsComponent,
    AdminListToolbarComponent,
  ],
})
export class TableCategoriesTreatmentsComponent extends BaseComponent implements OnInit {
  public treatmentsCategories: ITreatmentCategory[] = [];
  public filteredTreatmentsCategories: ITreatmentCategory[] = [];
  public searchValue = '';

  constructor(
    public readonly confirmationService: ConfirmationService,
    public readonly messageService: MessageService,
    public readonly treatmentsCategoriesService: TreatmentsCategoriesService,
    public readonly errorsService: ErrorsService,
    public readonly translate: TranslateService,
    public readonly session: SessionService,
    public readonly router: Router,
  ) {
    super(session);
  }

  onSearch(value: string): void {
    this.searchValue = value;
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredTreatmentsCategories = [...this.treatmentsCategories];
      return;
    }

    this.filteredTreatmentsCategories = this.treatmentsCategories.filter((category) =>
      (category.name || '').toLowerCase().includes(query),
    );
  }

  load(): void {
    this.treatmentsCategoriesService.getAll(this.customers_id).subscribe({
      next: (treatmentsCategories: ITreatmentCategory[]) => {
        this.treatmentsCategories = treatmentsCategories;
        this.onSearch(this.searchValue);
      },
      error: (error: any) => {
        const code = this.errorsService.getMessageFromTreatmentCategoryError(error);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('MESSAGES.TREATMENTS.CATEGORIES.ERROR.SUMMARY'),
          detail: this.translate.instant(`MESSAGES.TREATMENTS.CATEGORIES.ERROR.${code}`),
        });
      },
    });
  }

  confirmDelete(category: ITreatmentCategory): void {
    if (!category?.id) {
      return;
    }

    this.confirmationService.confirm({
      header: this.translate.instant('ADMIN.TREATMENTS.CATEGORIES.CONFIRM.DELETE.TITLE'),
      message: this.translate.instant('ADMIN.TREATMENTS.CATEGORIES.CONFIRM.DELETE.TEXT', {
        category: category.name,
      }),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.delete(category),
    });
  }

  private delete(category: ITreatmentCategory): void {
    if (!category?.id) {
      return;
    }

    this.treatmentsCategoriesService.delete(this.customers_id, category.id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant(
            'MESSAGES.SUCCESS.DELETE.TREATMENT_CATEGORIES.SUMMARY',
          ),
          detail: this.translate.instant(
            'MESSAGES.SUCCESS.DELETE.TREATMENT_CATEGORIES.DETAIL',
          ),
        });
        this.load();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('MESSAGES.COMMON.500.SUMMARY'),
          detail: this.translate.instant('MESSAGES.COMMON.500.DETAIL'),
        });
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.load();
  }
}
